import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "previewContainer", "filename"];

  chooseFile() {
    this.inputTarget.click();
  }

  readURL() {
    const input = this.inputTarget;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const url = URL.createObjectURL(file);

      if (this.hasFilenameTarget) {
        this.filenameTarget.textContent = file.name;
      }

      if (file.type.startsWith("image/")) {
        this.previewContainerTarget.innerHTML = `
          <img src="${url}" class="h-full w-full object-cover transition-opacity duration-300">
        `;
      } else if (file.type.startsWith("video/")) {
        this.previewContainerTarget.innerHTML = `
          <video src="${url}" class="h-full w-full object-cover transition-opacity duration-300" autoplay muted loop></video>
        `;
      } else {
        this.previewContainerTarget.innerHTML = `
           <div class="flex h-full w-full items-center justify-center text-slate-400 bg-slate-100 dark:bg-slate-800">
            <svg class="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
          </div>
        `;
      }
    }
  }
}
